
import React from 'react';
import 'weui';

const iconGoal = require('../images/icon_goal.png');
const iconCorner = require('../images/icon_corner.png');

export default class RaceItem extends React.Component {

  render() {
    const race = this.props.race;
    const league = race.league,
          leagueImg = 'http://static.dszuqiu.com/country/m/' + race.leagueImg + '.png',
          host = race.host,
          hostG = race.hostG,
          hostC = race.hostC,
          guest = race.guest,
          guestG = race.guestG,
          guestC = race.guestC,
          time = race.time,
          rq = race.rq ? race.rq : null,
          dxq = race.dxq ? race.dxq : null,
          start = race.start;
    return (
      <div className="raceItem" style={{display: time == '全' ? 'none' : null}}>
        <div className="raceLeague">
          <img src={leagueImg} />
          <span className="leagueName">{league}</span>
          <span className="raceTime">
            {(time == '全' || time == '半') ? time : (time + "\'")}
          </span>
        </div>
        <div className="raceInfo">
          <div className="raceTeam text-left right">
            <h4>{guest}</h4>
            <p className="racePankou">{dxq ? dxq[0] : '-'} / {dxq ? dxq[1] : '-'} / {dxq ? dxq[2] : '-'}</p>
          </div>
          <div className="raceTeam text-right left">
            <h4>{host}</h4>
            <p className="racePankou">{rq ? rq[0] : '-'} / {rq ? rq[1] : '-'} / {rq ? rq[2] : '-'}</p>
          </div>
          <div className="racePoint">
            <h4>{hostG} <img src={iconGoal} /> {guestG}</h4>
            <h4>{hostC} <img src={iconCorner} className="MT-3" /> {guestC}</h4>
          </div>
        </div>
      </div>
    );
  }
}

RaceItem.defaultProps = {
};

export default RaceItem;



/** WEBPACK FOOTER **
 ** ./src/components/RaceItem.js
 **/